import { globalI18nTransformPipeline } from "app/pages/sales-intelligence/services/text-transform";
import { INTENT_EMPTY_TOPIC_BANNER_I18N } from "../const";

import { StyledIntetEmptyTopicsBanner } from "./styles";
import { translate } from "app/filters/i18nFilter";

const IntentEmptyTopicsCompactBanner = () => {
    return (
        <StyledIntetEmptyTopicsBanner
            description={globalI18nTransformPipeline.apply(
                translate(INTENT_EMPTY_TOPIC_BANNER_I18N.descriptionMultiline.key),
            )}
        />
    );
};

export default IntentEmptyTopicsCompactBanner;
